export const LectureIndicatorStatus = {
    BASIC: 'BASIC',
    PROGRESS: 'PROGRESS',
    COMPLETED: 'COMPLETED',
    SUBMITTED: 'SUBMITTED',
    RESOLVED: 'RESOLVED',
};

export const CompletedIndicatorList = [
    LectureIndicatorStatus.COMPLETED,
    LectureIndicatorStatus.SUBMITTED,
    LectureIndicatorStatus.RESOLVED,
];

export const RenderTypes = {
    QUIZ_INDICATOR: 'QUIZ_INDICATOR',
    LECTURE_INDICATOR: 'LECTURE_INDICATOR',
    POPUP_LIST: 'POPUP_LIST',
    TOOL_TIP: 'TOOL_TIP',
    MISSION_INTRO: 'MISSION_INTRO',
    HINT_LIST: 'HINT_LIST',
};

export const ModalTypes = {
    ELEMENT: 'ELEMENT',
    ALERT: 'ALERT',
    CONFIRM: 'CONFIRM',
    FOLLOW: 'FOLLOW',
    INTRO: 'INTRO',
    HARDWARE_LIST: 'HARDWARE_LIST',
    OUTRO: 'OUTRO',
    HINT: 'HINT',
    PREBUILT_HINT: 'PREBUILT_HINT',
    COMPLETE: 'COMPLETE',
    PROJECT: 'PROJECT',
    MANUAL: 'MANUAL',
    LECTURE_PROGRESS: 'LECTURE_PROGRESS',
    LECTURE_PROGRESS2: 'LECTURE_PROGRESS2',
    TEXTBOOK_LECTURE_PROGRESS: 'TEXTBOOK_LECTURE_PROGRESS',
    MAZE: 'MAZE',
    DIARY: 'DIARY',
    MAZE_RESULT: 'MAZE_RESULT',
    LIST_EXPORT: 'LIST_EXPORT',
    LIST_IMPORT: 'LIST_IMPORT',
    USER_SELECT_LIST: 'USER_SELECT_LIST',
    CURRICULUM_ALERT: 'CURRICULUM_ALERT',
    CURRICULUM_ANSWER: 'CURRICULUM_ANSWER',
    CURRICULUM_HINT: 'CURRICULUM_HINT',
    CURRICULUM_STUDY_COMPLETE: 'CURRICULUM_STUDY_COMPLETE',
    HARDWARE_DOWNLOAD: 'HARDWARE_DOWNLOAD',
    SIMPLE: 'SIMPLE',
    TEXTAREA: 'TEXTAREA',
    LECTURE: 'LECTURE',
    STUDY_GOAL: 'STUDY_GOAL',
    BUTTON_LIST: 'BUTTON_LIST',
};

export const TitleTypes = {
    DEFAULT: 'DEFAULT',
    STOP: 'STOP',
    HINT: 'HINT',
    NOTION: 'NOTION',
};

export const PrebuiltHintTypes = {
    COORDINATE: 'COORDINATE',
    SUM_BLOCK: 'SUM_BLOCK',
    RANDOM_DIRECTION: 'RANDOM_DIRECTION',
    ROTATE: 'ROTATE',
    DIRECTION: 'DIRECTION',
    OBJECT: 'OBJECT',
    LAYER: 'LAYER',
    FOR_LOOP: 'FOR_LOOP',
    LOOP_TYPE: 'LOOP_TYPE',
    IF_BLOCK: 'IF_BLOCK',
    PROMPT: 'PROMPT',
    VARIABLE: 'VARIABLE',
    ADD_PICTURE: 'ADD_PICTURE',
    ADD_SOUND: 'ADD_SOUND',
    USE_VARIABLE: 'USE_VARIABLE',
};

export const ManualTypes = {
    FREE: 'FREE',
    MISSION: 'MISSION',
};

export const MediaStatusTypes = {
    NONE: 'NONE',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    EDWITH: 'EDWITH',
    BLOCK: 'BLOCK',
    PROJECT: 'PROJECT',
    ELEMENT: 'ELEMENT',
    PROJECT_ELEMENT: 'PROJECT_ELEMENT',
    LECTURE_PROJECT: 'LECTURE_PROJECT',
    LECTURE_PROJECT_ELEMENT: 'LECTURE_PROJECT_ELEMENT',
};

export const quizProgressTypes = {
    SOLVING: 'SOLVING',
    COMPLETE: 'COMPLETE',
};

export const pagerActionTypes = {
    PREV: 'PREV',
    NEXT: 'NEXT',
};

export const compStatusTypes = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
    HIDDEN: 'HIDDEN',
};

export const answerStatusTypes = {
    NONE: 'NONE',
    CORRECT: 'CORRECT',
    INCORRECT: 'INCORRECT',
};

export const HomeworkStatusTypes = {
    NONE: 'NONE',
    HOMEWORK: 'HOMEWORK',
    DUE_LAPSE: 'DUE_LAPSE',
};

export const LectureProgressContentTypes = {
    CURRICULUM: 'CURRICULUM',
    LECTURE: 'LECTURE',
};

export const ThemeTypes = {
    BLUE: 'BLUE',
    CP2017S2: 'CP2017S2',
    LINE: 'LINE',
};

export const ContentTypes = {
    IMAGE: 'IMAGE',
    BLOCK: 'BLOCK',
    CHARACTER_TEXT: 'CHARACTER_TEXT',
    TEXT: 'TEXT',
};

export const HardwareModalMode = {
    VIEWER: 'VIEWER',
    SELECT: 'SELECT',
};



// WEBPACK FOOTER //
// ./Constants.js